import React from 'react';
import styles from './EnableAutoReplyDrawer.module.css';

interface EnableAutoReplyDrawerBodyProps {
	paymentLabel: string;
	addressLabel: string;
}

function AddressArrowIcon(): React.ReactElement {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden>
			<path d="M13 23V5L25 14L13 23Z" fill="black" />
			<path d="M12.9972 13H3V15H12.9972V13Z" fill="black" />
		</svg>
	);
}

export function EnableAutoReplyDrawerBody({
	paymentLabel,
	addressLabel,
}: EnableAutoReplyDrawerBodyProps): React.ReactElement {
	return (
		<div className={styles.body}>
			<p className={styles.description}>
				Когда придёт подходящее предложение, вы автоматически на него откликнитесь
			</p>

			<div className={styles.fields}>
				<div className={styles.field}>
					<span className={styles.label}>Оплата</span>
					<span className={styles.value}>{paymentLabel}</span>
				</div>

				<div className={styles.field}>
					<span className={styles.label}>Адрес</span>
					<div className={styles.addressRow}>
						<span className={styles.value}>{addressLabel}</span>
						<span className={styles.addressArrow}>
							<AddressArrowIcon />
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}
